import { Box, Stack, Typography } from "@mui/material";
import * as React from "react";

const TARGET_DATE = new Date("2026-05-20T00:00:00+02:00"); // 20.05.2026 (CET/CEST)

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

function getTimeLeft(): TimeLeft {
  const now = new Date().getTime();
  const target = TARGET_DATE.getTime();
  const diff = Math.max(target - now, 0);

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  return { days, hours, minutes, seconds };
}

export function SaveTheDateView() {
  const [timeLeft, setTimeLeft] = React.useState<TimeLeft>(getTimeLeft);

  React.useEffect(() => {
    const interval = window.setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);

    return () => window.clearInterval(interval);
  }, []);

  const segments = [
    { label: "Tage", value: timeLeft.days },
    { label: "Stunden", value: timeLeft.hours },
    { label: "Minuten", value: timeLeft.minutes },
    { label: "Sekunden", value: timeLeft.seconds },
  ];

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 10000,

        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        paddingTop: { xs: "20%", lg: "10%" },
        paddingX: 2,
        bgcolor: "#ffffff",
        color: "#ffffff",
      }}
    >
      <Stack spacing={4} alignItems="center" sx={{ width: "100%" }}>
        {/* Bild oben, max 800px, maxWidth 90% */}
        <Box
          sx={{
            width: "90%",
            maxWidth: 800,
            aspectRatio: "16 / 9",
            backgroundImage: 'url("/img/save-the-date-bg.jpg")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            borderRadius: 2,
            boxShadow: 2,
          }}
        />

        {/* Countdown darunter, max 800px Breite mit Gap */}
        <Stack
          direction="row"
          spacing={{ xs: 2.5, sm: 3, md: 4 }}
          justifyContent="center"
          alignItems="center"
          sx={{
            width: "90%",
            maxWidth: 400,
            textAlign: "center",
          }}
        >
          {segments.map((segment) => (
            <Box
              key={segment.label}
              // sx={{
              //   flex: 1,
              //   minWidth: { xs: 55, sm: 65, md: 75 },
              //   px: { xs: 2.2, sm: 2.6, md: 3 },
              //   py: { xs: 1.6, sm: 2, md: 2.4 },
              //   borderRadius: 3,
              //   border: "2px solid rgba(0,0,0,0.08)",
              //   bgcolor: "#ec4899",
              //   boxShadow: 2,
              // }}
            >
              <Typography
                // fontWeight={700}
                sx={{
                  mb: 0.5,
                  // fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.6rem" },
                  fontSize: { xs: "0.6rem", md: "0.8rem" },
                  color: "#000000",
                  opacity: 0.8,
                }}
              >
                {segment.value.toString().padStart(2, "0")}
              </Typography>
              <Typography
                sx={{
                  letterSpacing: 2,
                  textTransform: "uppercase",
                  fontSize: {
                    xs: "0.6rem",
                    md: "0.8rem",
                    // xs: "0.4rem",
                    // sm: "0.5rem",
                    // md: "0.6rem",
                    color: "#000000",
                    opacity: 0.8,
                  },
                  // opacity: 0.9,
                }}
              >
                {segment.label}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
}
